export const DATA_STEPS = {
  CONTRACT: 'CONTRAT',
  SUBSCRIPTION: 'SOUSCRIPTION'
};

/**
 *
 * @param {function} getMiddleBoolean
 * @param {string} dataStep DATA_STEPS.CONTRACT ou DATA_STEPS.SUBSCRIPTION
 * @returns {(fieldKey: string) => {
 *   isNecessary: boolean,
 *   isRequired: boolean,
 *   askedAtContract: boolean,
 *   askedAtSubscription: boolean,
 *   isDisplayed: boolean,
 *   disabled: boolean
 * }}
 */
export const adherentFieldFlags =
  (getMiddleBoolean, dataStep) => (fieldKey) => {
    const flag = (suffix) => Boolean(getMiddleBoolean(`${fieldKey}_${suffix}`));

    const isNecessary = flag('EST_NECESSAIRE');
    const isRequired = flag('EST_OBLIGATOIRE');
    const askedAtContract = flag('EST_DEMANDE_DONNEES_CONTRAT');
    const askedAtSubscription = flag('EST_DEMANDE_DONNEES_SOUSCRIPTION');

    const onSubscriptionStep = dataStep === DATA_STEPS.SUBSCRIPTION;

    return {
      isNecessary,
      isRequired,
      askedAtContract,
      askedAtSubscription,
      isDisplayed:
        isNecessary &&
        (onSubscriptionStep
          ? askedAtContract || askedAtSubscription
          : askedAtContract),
      disabled: onSubscriptionStep && isRequired && askedAtContract
    };
  };
